import { c as _c } from "react/compiler-runtime";
import { disabledVariants } from "@opensea/ui-kit";
import { Star, StarFilled } from "@opensea/ui-kit/icons";
export function CollectionWatchlistIcon(t0) {
  const $ = _c(4);
  const {
    isFilled,
    loading,
    size: t1
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] !== isFilled || $[1] !== loading || $[2] !== size) {
    t2 = isFilled ? <StarFilled fill="warning" size={size} /> : <Star className={disabledVariants({
      disabled: loading
    })} size={size} />;
    $[0] = isFilled;
    $[1] = loading;
    $[2] = size;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}